'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _dec2, _class2, _class3, _temp3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _chapter = require('redux/modules/chapter');

var _schoollevels = require('redux/modules/schoollevels');

var _copy = require('../../redux/modules/copy');

var _reactRouter = require('react-router');

var _components = require('components');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

var _strings = require('utils/strings');

var _reactDraggableList = require('react-draggable-list');

var _reactDraggableList2 = _interopRequireDefault(_reactDraggableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ListItem, _Component);

  function ListItem() {
    (0, _classCallCheck3.default)(this, ListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dragHandle = _props.dragHandle,
          item = _props.item,
          itemSelected = _props.itemSelected;

      var dragged = itemSelected > 0.75;
      var styles = require('./Chapter.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.listItem + (dragged ? ' dragged' : '') },
        dragHandle(_react2.default.createElement(
          'div',
          null,
          item.label
        ))
      );
    }
  }]);
  return ListItem;
}(_react.Component), _class.propTypes = {
  dragHandle: _react.PropTypes.func.isRequired,
  item: _react.PropTypes.object.isRequired,
  itemSelected: _react.PropTypes.number.isRequired
}, _temp);
var Chapter = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(options) {
    var dispatch = options.store.dispatch,
        chapterId = options.params.chapterId;


    return _promise2.default.all([dispatch((0, _chapter.load)(chapterId)), dispatch((0, _schoollevels.load)())]);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    chapter: state.chapter.data,
    loading: state.chapter.loading,
    saving: state.chapter.saving,
    copying: state.copy.copying,
    copyError: state.copy.error
  };
}), _dec(_class2 = _dec2(_class2 = (_temp3 = _class3 = function (_Component2) {
  (0, _inherits3.default)(Chapter, _Component2);

  function Chapter() {
    var _ref;

    var _temp2, _this2, _ret;

    (0, _classCallCheck3.default)(this, Chapter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = Chapter.__proto__ || (0, _getPrototypeOf2.default)(Chapter)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      chapter: undefined,
      addingDocument: false,
      editing: false,
      fieldErrors: {},
      slug: undefined,
      title: undefined,
      published: undefined,
      saving: false,
      addingSection: false,
      sectionModalVisible: false,
      sectionModalObject: {},
      sectionModalFieldErrors: {},
      documentModalVisible: false,
      documentModalObject: {},
      documentModalFieldErrors: {},
      sortingModalVisible: false,
      sortingModalReferences: [],
      sortingModalSectionIndex: undefined,
      sortingModalUpdatedList: [],
      deletingModalVisible: false,
      deletingModalObject: undefined,
      documentCopyModalVisible: false,
      documentCopyModalObject: {},
      matrixDocumentIndex: -1,
      matrixSectionIndex: -1,
      requirements: {}
    }, _this2.componentWillMount = function () {
      var chapter = _this2.props.chapter;

      _this2.setState({
        chapter: chapter
      });
    }, _this2.componentWillReceiveProps = function (nextProps) {
      var saving = nextProps.saving,
          chapter = nextProps.chapter;

      var prevSaving = _this2.state.saving;

      _this2.setState({
        saving: saving
      });

      if (saving === false && prevSaving === true) {
        _this2.setState({
          chapter: chapter,
          editing: false,
          sectionModalVisible: false,
          documentModalVisible: false,
          sortingModalVisible: false,
          deletingModalVisible: false,
          documentCopyModalVisible: false,
          matrixModalVisible: false
        });
      }

      if (_this2.props.copying && !nextProps.copying && !nextProps.copyError) {
        _this2.setState({
          documentCopyModalVisible: false
        });
      }
    }, _this2.onListChange = function (newList) {
      _this2.setState({
        sortingModalReferences: newList
      });
    }, _this2.togglePublishSectionModal = function () {
      var sectionModalObject = _this2.state.sectionModalObject;

      sectionModalObject.published = !sectionModalObject.published;
      _this2.setState({
        sectionModalObject: sectionModalObject
      });
    }, _this2.togglePublishDocumentModal = function () {
      var documentModalObject = _this2.state.documentModalObject;

      documentModalObject.published = !documentModalObject.published;
      _this2.setState({
        documentModalObject: documentModalObject
      });
    }, _this2.togglePublish = function () {
      var published = _this2.state.published;

      _this2.setState({
        published: !published
      });
    }, _this2.toggleIsTestQuiz = function () {
      var documentModalObject = _this2.state.documentModalObject;

      console.log({ documentModalObject: documentModalObject });
      documentModalObject.isTest = !documentModalObject.isTest;
      console.log({ documentModalObject: documentModalObject });
      _this2.setState({
        documentModalObject: documentModalObject
      });
    }, _this2.handleCloseDocumentModal = function () {
      _this2.setState({
        documentModalVisible: false
      });
    }, _this2.handleStartEditing = function () {
      var chapter = _this2.state.chapter;

      _this2.setState({
        editing: true,
        title: chapter.title,
        slug: chapter.slug,
        published: chapter.published
      });
    }, _this2.handleStopEditing = function () {
      _this2.setState({
        editing: false
      });
    }, _this2.handleRemoveChapter = function () {
      var chapter = _this2.state.chapter;

      _this2.props.dispatch((0, _chapter.remove)(chapter));
    }, _this2.handleFieldChange = function (param, event) {
      var _this2$setState;

      var fieldErrors = _this2.state.fieldErrors;

      fieldErrors[param] = null;

      if (param === 'title') {
        _this2.setState({
          slug: (0, _strings.slugify)(event.target.value)
        });
      }

      _this2.setState((_this2$setState = {}, (0, _defineProperty3.default)(_this2$setState, param, event.target.value), (0, _defineProperty3.default)(_this2$setState, 'fieldErrors', fieldErrors), _this2$setState));
    }, _this2.handleSaveDocumentModal = function () {
      event.preventDefault();

      var _this2$state = _this2.state,
          documentModalObject = _this2$state.documentModalObject,
          chapter = _this2$state.chapter;


      _this2.setState({ documentModalFieldErrors: {} });
      var documentModalFieldErrors = {};
      if (!documentModalObject.title) {
        documentModalFieldErrors.title = 'Champs requis';
      }
      if (!documentModalObject.slug) {
        documentModalFieldErrors.slug = 'Champs requis';
      }
      if (!documentModalObject.type) {
        documentModalFieldErrors.iconClass = 'Champs requis';
      }

      if (documentModalObject.type === 'video' && !documentModalObject.mediaId) {
        documentModalFieldErrors.mediaId = 'Champs requis';
      }

      _this2.setState({ documentModalFieldErrors: documentModalFieldErrors });

      if ((0, _keys2.default)(documentModalFieldErrors).length === 0) {
        var sectionIndex = documentModalObject.sectionIndex,
            index = documentModalObject.index;

        if (index > -1) {
          var _document = {
            chapterId: chapter._id,
            _id: chapter.documentsSections[sectionIndex].documents[index]._id._id,
            title: documentModalObject.title,
            slug: documentModalObject.slug,
            type: documentModalObject.type,
            published: documentModalObject.published,
            mediaId: documentModalObject.mediaId,
            isTest: documentModalObject.isTest
          };
          _this2.props.dispatch((0, _chapter.updateDocumentInfos)(_document));
        } else {
          var newDocument = {
            chapterId: chapter._id,
            sectionSlug: chapter.documentsSections[sectionIndex].slug,
            title: documentModalObject.title,
            slug: documentModalObject.slug,
            type: documentModalObject.type,
            published: documentModalObject.published,
            mediaId: documentModalObject.mediaId,
            isTest: documentModalObject.isTest
          };
          _this2.props.dispatch((0, _chapter.createDocument)(newDocument));
        }
      }
    }, _this2.handleSaveChapter = function (event) {
      event.preventDefault();

      var _this2$state2 = _this2.state,
          chapter = _this2$state2.chapter,
          slug = _this2$state2.slug,
          title = _this2$state2.title,
          published = _this2$state2.published;


      _this2.setState({ fieldErrors: {} });
      var fieldErrors = {};
      if (!title) {
        fieldErrors.title = 'Champs requis';
      }
      if (!slug) {
        fieldErrors.slug = 'Champs requis';
      }

      _this2.setState({ fieldErrors: fieldErrors });

      if ((0, _keys2.default)(fieldErrors).length === 0) {
        chapter.title = title;
        chapter.slug = slug;
        chapter.published = published;
        _this2.props.dispatch((0, _chapter.save)(chapter));
      }
    }, _this2.handleStartAddingSection = function () {
      _this2.setState({
        sectionModalVisible: true,
        sectionModalObject: {
          iconClass: 'exercise',
          index: -1,
          published: false
        },
        sectionModalFieldErrors: {}
      });
    }, _this2.handleCloseSectionModal = function () {
      _this2.setState({
        sectionModalVisible: false
      });
    }, _this2.handleStartEditingSection = function (sectionIndex) {
      var chapter = _this2.state.chapter;

      var section = chapter.documentsSections[sectionIndex];
      _this2.setState({
        sectionModalVisible: true,
        sectionModalObject: (0, _extends3.default)({}, section, { index: sectionIndex }),
        sectionModalFieldErrors: {}
      });
    }, _this2.handleDocumentModalFieldChange = function (param, event) {
      var _this2$state3 = _this2.state,
          documentModalFieldErrors = _this2$state3.documentModalFieldErrors,
          documentModalObject = _this2$state3.documentModalObject;

      documentModalFieldErrors[param] = null;

      if (param === 'title') {
        documentModalObject.slug = (0, _strings.slugify)(event.target.value);
      }

      documentModalObject[param] = event.target.value;

      _this2.setState({
        documentModalObject: documentModalObject,
        documentModalFieldErrors: documentModalFieldErrors
      });
    }, _this2.handleSectionModalFieldChange = function (param, event) {
      var _this2$state4 = _this2.state,
          sectionModalFieldErrors = _this2$state4.sectionModalFieldErrors,
          sectionModalObject = _this2$state4.sectionModalObject;

      sectionModalFieldErrors[param] = null;

      if (param === 'title') {
        sectionModalObject.slug = (0, _strings.slugify)(event.target.value);
      }

      sectionModalObject[param] = event.target.value;

      _this2.setState({
        sectionModalObject: sectionModalObject,
        sectionModalFieldErrors: sectionModalFieldErrors
      });
    }, _this2.handleSaveSectionModal = function () {
      event.preventDefault();

      var _this2$state5 = _this2.state,
          sectionModalObject = _this2$state5.sectionModalObject,
          chapter = _this2$state5.chapter;


      _this2.setState({ sectionModalFieldErrors: {} });
      var sectionModalFieldErrors = {};
      if (!sectionModalObject.title) {
        sectionModalFieldErrors.title = 'Champs requis';
      }
      if (!sectionModalObject.slug) {
        sectionModalFieldErrors.slug = 'Champs requis';
      }
      if (!sectionModalObject.iconClass) {
        sectionModalFieldErrors.iconClass = 'Champs requis';
      }

      _this2.setState({ sectionModalFieldErrors: sectionModalFieldErrors });

      if ((0, _keys2.default)(sectionModalFieldErrors).length === 0) {
        if (sectionModalObject.index > -1) {
          chapter.documentsSections[sectionModalObject.index].title = sectionModalObject.title;
          chapter.documentsSections[sectionModalObject.index].iconClass = sectionModalObject.iconClass;
          chapter.documentsSections[sectionModalObject.index].slug = sectionModalObject.slug;
          chapter.documentsSections[sectionModalObject.index].published = sectionModalObject.published;
        } else {
          chapter.documentsSections.push({
            title: sectionModalObject.title,
            slug: sectionModalObject.slug,
            iconClass: sectionModalObject.iconClass,
            rank: chapter.documentsSections.length + 1,
            documents: [],
            published: sectionModalObject.published
          });
        }
        _this2.props.dispatch((0, _chapter.save)(chapter));
      }
    }, _this2.handleStartAddingDocument = function (sectionIndex) {
      _this2.setState({
        documentModalVisible: true,
        documentModalObject: {
          sectionIndex: sectionIndex,
          index: -1,
          type: 'exercisesSheet',
          published: false
        },
        documentModalFieldErrors: {}
      });
    }, _this2.handleStartCopyDocument = function (sectionIndex, documentIndex) {
      var chapter = _this2.state.chapter;

      var document = chapter.documentsSections[sectionIndex].documents[documentIndex];

      _this2.setState({
        documentCopyModalVisible: true,
        documentCopyModalObject: {
          document: document,
          schoolLevelIndex: 0,
          chapterIndex: 0,
          documentsSectionIndex: 0
        }
      });
    }, _this2.handleCopyDocumentModalFieldChange = function (param, event) {
      var documentCopyModalObject = _this2.state.documentCopyModalObject;


      documentCopyModalObject[param] = event.target.value;

      if (param === 'schoolLevelIndex') {
        documentCopyModalObject.chapterIndex = 0;
      }

      if (param === 'schoolLevelIndex' || param === 'chapterIndex') {
        documentCopyModalObject.documentsSectionIndex = 0;
      }

      _this2.setState({
        documentCopyModalObject: documentCopyModalObject
      });
    }, _this2.handleCloseDocumentCopyModal = function () {
      _this2.setState({
        documentCopyModalVisible: false
      });
    }, _this2.handleSaveCopyDocumentModal = function () {
      var documentCopyModalObject = _this2.state.documentCopyModalObject;
      var schoolLevels = _this2.props.schoolLevels;
      var document = documentCopyModalObject.document,
          schoolLevelIndex = documentCopyModalObject.schoolLevelIndex,
          chapterIndex = documentCopyModalObject.chapterIndex,
          documentsSectionIndex = documentCopyModalObject.documentsSectionIndex;


      var documentId = document._id._id;
      var chapterId = schoolLevels[schoolLevelIndex].chapters[chapterIndex]._id._id;

      _this2.props.dispatch((0, _copy.copyDocument)({
        documentId: documentId,
        destChapterId: chapterId,
        destDocumentsSectionIndex: parseInt(documentsSectionIndex, 10)
      }));
    }, _this2.handleStartEditingDocument = function (sectionIndex, documentIndex) {
      var chapter = _this2.state.chapter;

      var document = chapter.documentsSections[sectionIndex].documents[documentIndex];

      _this2.setState({
        documentModalVisible: true,
        documentModalObject: {
          sectionIndex: sectionIndex,
          index: documentIndex,
          id: document._id._id,
          type: document._id.type,
          title: document._id.title,
          slug: document._id.slug,
          published: document._id.published,
          isTest: document._id.isTest,
          mediaId: document._id.media ? document._id.media.mediaId : ''
        },
        documentModalFieldErrors: {}
      });
    }, _this2.handleStartSorting = function (sectionIndex) {
      var references = void 0;
      var chapter = _this2.state.chapter;

      if (sectionIndex === -1) {
        references = chapter.documentsSections.map(function (documentsSection, index) {
          return {
            id: index,
            label: documentsSection.title,
            index: index
          };
        });
      } else {
        references = chapter.documentsSections[sectionIndex].documents.map(function (document, index) {
          return {
            id: index,
            label: document._id.title,
            index: document.rank
          };
        });
      }
      _this2.setState({
        sortingModalVisible: true,
        sortingModalSectionIndex: sectionIndex,
        sortingModalReferences: references
      });
    }, _this2.handleSaveSortingModal = function () {
      var _this2$state6 = _this2.state,
          sortingModalReferences = _this2$state6.sortingModalReferences,
          sortingModalSectionIndex = _this2$state6.sortingModalSectionIndex,
          chapter = _this2$state6.chapter;


      if (sortingModalSectionIndex === -1) {
        sortingModalReferences.forEach(function (reference, index) {
          chapter.documentsSections[reference.id].rank = index + 1;
        });
      } else {
        sortingModalReferences.forEach(function (reference, index) {
          chapter.documentsSections[sortingModalSectionIndex].documents[reference.id].rank = index + 1;
        });
      }

      _this2.props.dispatch((0, _chapter.save)(chapter));
    }, _this2.handleCloseSortingModal = function () {
      _this2.setState({
        sortingModalVisible: false
      });
    }, _this2.handleCloseDeletingModal = function () {
      _this2.setState({
        deletingModalVisible: false
      });
    }, _this2.handleStartDeletingDocument = function (sectionIndex, documentIndex) {
      var chapter = _this2.state.chapter;

      var object = {
        type: 'document',
        id: chapter.documentsSections[sectionIndex].documents[documentIndex]._id._id,
        label: chapter.documentsSections[sectionIndex].documents[documentIndex]._id.title
      };
      _this2.setState({
        deletingModalVisible: true,
        deletingModalObject: object
      });
    }, _this2.handleStartDeletingSection = function (sectionIndex) {
      var chapter = _this2.state.chapter;

      var section = chapter.documentsSections[sectionIndex];
      if (section.documents.length === 0) {
        var object = {
          type: 'section',
          index: sectionIndex,
          label: section.title
        };
        _this2.setState({
          deletingModalVisible: true,
          deletingModalObject: object
        });
      }
    }, _this2.handleSaveDeletingModal = function () {
      var _this2$state7 = _this2.state,
          deletingModalObject = _this2$state7.deletingModalObject,
          chapter = _this2$state7.chapter;


      if (deletingModalObject.type === 'section') {
        var index = deletingModalObject.index;

        chapter.documentsSections.splice(index, 1);
        chapter.documentsSections.forEach(function (section, sectionIndex) {
          chapter.documentsSections[sectionIndex].rank = sectionIndex + 1;
        });
        _this2.props.dispatch((0, _chapter.save)(chapter));
      } else if (deletingModalObject.type === 'document') {
        _this2.props.dispatch((0, _chapter.removeDocument)(deletingModalObject.id));
      }
    }, _this2.handleOpenMatrixModal = function () {
      var chapter = _this2.props.chapter;

      var requirements = chapter.requirements || {};
      _this2.setState({
        matrixModalVisible: true,
        requirements: JSON.parse((0, _stringify2.default)(requirements))
      });
    }, _this2.handleCloseMatrixModal = function () {
      _this2.setState({
        matrixModalVisible: false
      });
    }, _this2.handleSaveMatrixModal = function () {
      var _this2$state8 = _this2.state,
          requirements = _this2$state8.requirements,
          chapter = _this2$state8.chapter;

      _this2.props.dispatch((0, _chapter.saveRequirements)(chapter._id, requirements));
    }, _this2.handleMouseOver = function (documentIndex, documentRelatedIndex) {
      _this2.setState({
        matrixHoverIndex: documentIndex,
        matrixHoverRelatedIndex: documentRelatedIndex
      });
    }, _this2.handleMatrixClick = function (documentId, documentRelatedId) {
      var requirements = _this2.state.requirements;

      if (requirements[documentId]) {
        var index = requirements[documentId].indexOf(documentRelatedId);
        if (index === -1) {
          requirements[documentId].push(documentRelatedId);
        } else {
          requirements[documentId].splice(index, 1);
        }
      } else {
        requirements[documentId] = [documentRelatedId];
      }

      _this2.setState({ requirements: requirements });
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(Chapter, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          chapter = _state.chapter,
          requirements = _state.requirements,
          editing = _state.editing,
          title = _state.title,
          published = _state.published,
          fieldErrors = _state.fieldErrors,
          slug = _state.slug,
          saving = _state.saving,
          sectionModalVisible = _state.sectionModalVisible,
          sectionModalObject = _state.sectionModalObject,
          sectionModalFieldErrors = _state.sectionModalFieldErrors,
          documentModalVisible = _state.documentModalVisible,
          documentModalObject = _state.documentModalObject,
          documentModalFieldErrors = _state.documentModalFieldErrors,
          sortingModalVisible = _state.sortingModalVisible,
          sortingModalReferences = _state.sortingModalReferences,
          deletingModalVisible = _state.deletingModalVisible,
          deletingModalObject = _state.deletingModalObject,
          documentCopyModalVisible = _state.documentCopyModalVisible,
          documentCopyModalObject = _state.documentCopyModalObject,
          matrixHoverRelatedIndex = _state.matrixHoverRelatedIndex,
          matrixHoverIndex = _state.matrixHoverIndex,
          matrixModalVisible = _state.matrixModalVisible;

      var styles = require('./Chapter.scss');
      var _props2 = this.props,
          routeParams = _props2.routeParams,
          schoolLevels = _props2.schoolLevels;


      var schoolLevel = schoolLevels.find(function (level) {
        return level._id === routeParams.schoolLevelId;
      });

      if (chapter) {
        var orderedSections = chapter.documentsSections.sort(function (first, second) {
          return first.rank - second.rank;
        });

        var matrix = [];

        var documentsCount = 0;
        orderedSections.forEach(function (section, sectionIndex) {
          var orderedDocuments = section.documents.sort(function (first, second) {
            return first.rank - second.rank;
          });

          matrix.push({ label: section.title, documents: [] });

          orderedDocuments.forEach(function (document) {
            if (document._id.type === 'exercisesSheet') {
              document._id.exercises.forEach(function (exercise, exerciseIndex) {
                matrix[sectionIndex].documents.push({
                  id: document._id._id + '/' + exercise._id,
                  label: document._id.title + ' / Exercice ' + (exerciseIndex + 1),
                  globalIndex: documentsCount
                });
                documentsCount += 1;
              });
            } else {
              matrix[sectionIndex].documents.push({
                id: document._id._id + '',
                label: document._id.title,
                globalIndex: documentsCount
              });
              documentsCount += 1;
            }
          });
        });

        return _react2.default.createElement(
          'div',
          { className: styles.chapter },
          documentModalVisible ? _react2.default.createElement(
            _components.Modal,
            { onCancel: this.handleCloseDocumentModal, onSave: this.handleSaveDocumentModal, saving: saving },
            _react2.default.createElement(
              'form',
              { className: styles.form },
              _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'title' },
                  'Titre'
                ),
                _react2.default.createElement('input', { className: styles.inputFieldInput, type: 'text',
                  name: 'title',
                  value: documentModalObject.title,
                  onChange: this.handleDocumentModalFieldChange.bind(null, 'title') }),
                _react2.default.createElement(
                  'span',
                  null,
                  documentModalFieldErrors.title
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'slug' },
                  'URL'
                ),
                _react2.default.createElement('input', { className: styles.inputFieldInput, type: 'text',
                  name: 'slug',
                  value: documentModalObject.slug,
                  disabled: 'disabled',
                  onChange: this.handleDocumentModalFieldChange.bind(null, 'slug') }),
                _react2.default.createElement(
                  'span',
                  null,
                  documentModalFieldErrors.slug
                )
              ),
              documentModalObject.index === -1 ? _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'type' },
                  'Type'
                ),
                _react2.default.createElement(
                  'select',
                  { className: styles.inputFieldInput,
                    name: 'type',
                    value: documentModalObject.type,
                    onChange: this.handleDocumentModalFieldChange.bind(null, 'type') },
                  _react2.default.createElement(
                    'option',
                    { value: 'video' },
                    'Vid\xE9o'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'exercisesSheet' },
                    'Fiche d\'exercices'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'lessonSheet' },
                    'Fiche de cours'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'quiz' },
                    'Quiz'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  documentModalFieldErrors.type
                )
              ) : null,
              documentModalObject.type === 'video' && _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'mediaId' },
                  'Media Id'
                ),
                _react2.default.createElement('input', { className: styles.inputFieldInput, type: 'text',
                  name: 'mediaId',
                  value: documentModalObject.mediaId,
                  onChange: this.handleDocumentModalFieldChange.bind(null, 'mediaId') }),
                _react2.default.createElement(
                  'span',
                  null,
                  documentModalFieldErrors.mediaId
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'published' },
                  'Publi\xE9'
                ),
                _react2.default.createElement('input', { type: 'checkbox',
                  name: 'published',
                  checked: documentModalObject.published,
                  onClick: this.togglePublishDocumentModal })
              ),
              documentModalObject.type === 'quiz' && _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'isTest' },
                  'Evaluation'
                ),
                _react2.default.createElement('input', { type: 'checkbox',
                  name: 'isTest',
                  checked: documentModalObject.isTest,
                  onClick: this.toggleIsTestQuiz })
              )
            )
          ) : null,
          sortingModalVisible ? _react2.default.createElement(
            _components.Modal,
            { onCancel: this.handleCloseSortingModal, onSave: this.handleSaveSortingModal, saving: saving },
            _react2.default.createElement(_reactDraggableList2.default, {
              itemKey: 'id',
              template: ListItem,
              list: sortingModalReferences,
              onMoveEnd: function onMoveEnd(newList) {
                return _this3.onListChange(newList);
              },
              container: function container() {
                return document.body;
              }
            })
          ) : null,
          deletingModalVisible ? _react2.default.createElement(
            _components.Modal,
            { onCancel: this.handleCloseDeletingModal, onSave: this.handleSaveDeletingModal, saving: saving },
            deletingModalObject.type === 'document' ? _react2.default.createElement(
              'div',
              null,
              'Le document \xAB ',
              deletingModalObject.label,
              ' \xBB va \xEAtre supprim\xE9e.'
            ) : null,
            deletingModalObject.type === 'section' ? _react2.default.createElement(
              'div',
              null,
              'La section \xAB ',
              deletingModalObject.label,
              ' \xBB va \xEAtre supprim\xE9.'
            ) : null
          ) : null,
          documentCopyModalVisible ? _react2.default.createElement(
            _components.Modal,
            { onCancel: this.handleCloseDocumentCopyModal, onSave: this.handleSaveCopyDocumentModal, saving: this.props.copying },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Copie du document : ',
                _react2.default.createElement(
                  'b',
                  null,
                  documentCopyModalObject.document._id.title
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'Destination'
                ),
                ' : '
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'form',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'label',
                    { className: styles.inputFieldLabel, htmlFor: 'iconClass' },
                    'Niveau'
                  ),
                  _react2.default.createElement(
                    'select',
                    { className: styles.inputFieldInput,
                      name: 'schoolLevelIndex',
                      onChange: this.handleCopyDocumentModalFieldChange.bind(null, 'schoolLevelIndex') },
                    schoolLevels.map(function (level, index) {
                      return _react2.default.createElement(
                        'option',
                        { value: index },
                        level.name
                      );
                    })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    fieldErrors.schoolLevel
                  )
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'label',
                    { className: styles.inputFieldLabel, htmlFor: 'iconClass' },
                    'Chapitre'
                  ),
                  _react2.default.createElement(
                    'select',
                    { className: styles.inputFieldInput,
                      name: 'chapterIndex',
                      onChange: this.handleCopyDocumentModalFieldChange.bind(null, 'chapterIndex') },
                    schoolLevels[documentCopyModalObject.schoolLevelIndex].chapters.map(function (levelChapter, index) {
                      return _react2.default.createElement(
                        'option',
                        { value: index },
                        levelChapter._id.title
                      );
                    })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    fieldErrors.chapter
                  )
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'label',
                    { className: styles.inputFieldLabel, htmlFor: 'iconClass' },
                    'Section'
                  ),
                  _react2.default.createElement(
                    'select',
                    { className: styles.inputFieldInput,
                      name: 'documentsSectionIndex',
                      onChange: this.handleCopyDocumentModalFieldChange.bind(null, 'documentsSectionIndex') },
                    schoolLevels[documentCopyModalObject.schoolLevelIndex].chapters[documentCopyModalObject.chapterIndex]._id.documentsSections.map(function (documentSection, index) {
                      return _react2.default.createElement(
                        'option',
                        { value: index },
                        documentSection.title
                      );
                    })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    fieldErrors.documentsSection
                  )
                )
              )
            )
          ) : null,
          sectionModalVisible ? _react2.default.createElement(
            _components.Modal,
            { onCancel: this.handleCloseSectionModal, onSave: this.handleSaveSectionModal, saving: saving },
            _react2.default.createElement(
              'form',
              { className: styles.form },
              _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'title' },
                  'Titre'
                ),
                _react2.default.createElement('input', { className: styles.inputFieldInput, type: 'text',
                  name: 'title',
                  value: sectionModalObject.title,
                  onChange: this.handleSectionModalFieldChange.bind(null, 'title') }),
                _react2.default.createElement(
                  'span',
                  null,
                  sectionModalFieldErrors.title
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'name' },
                  'URL'
                ),
                _react2.default.createElement('input', { className: styles.inputFieldInput, type: 'text',
                  name: 'slug',
                  value: sectionModalObject.slug,
                  disabled: 'disabled',
                  onChange: this.handleSectionModalFieldChange.bind(null, 'slug') }),
                _react2.default.createElement(
                  'span',
                  null,
                  sectionModalFieldErrors.slug
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'iconClass' },
                  'Ic\xF4ne'
                ),
                _react2.default.createElement(
                  'select',
                  { className: styles.inputFieldInput,
                    name: 'iconClass',
                    value: sectionModalObject.iconClass,
                    onChange: this.handleSectionModalFieldChange.bind(null, 'iconClass') },
                  _react2.default.createElement(
                    'option',
                    { value: 'exercise' },
                    'Exercice'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'test' },
                    'Contr\xF4le'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'video' },
                    'Vid\xE9o'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'bac' },
                    'Bac'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  fieldErrors.iconClass
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.line },
                _react2.default.createElement(
                  'label',
                  { className: styles.inputFieldLabel, htmlFor: 'published' },
                  'Publi\xE9'
                ),
                _react2.default.createElement('input', { type: 'checkbox',
                  name: 'published',
                  checked: sectionModalObject.published,
                  onClick: this.togglePublishSectionModal })
              )
            )
          ) : null,
          matrixModalVisible && _react2.default.createElement(
            _components.Modal,
            { onCancel: this.handleCloseMatrixModal, onSave: this.handleSaveMatrixModal, saving: saving },
            _react2.default.createElement(
              'table',
              { className: styles.matrix },
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: '2' },
                    '\xA0'
                  ),
                  [].concat((0, _toConsumableArray3.default)(Array(documentsCount))).map(function (element, index) {
                    return _react2.default.createElement(
                      'td',
                      null,
                      index + 1
                    );
                  })
                )
              ),
              matrix.length > 0 ? matrix.map(function (section) {
                return _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      { colSpan: documentsCount + 2 },
                      section.label
                    )
                  ),
                  section.documents.map(function (document) {
                    return _react2.default.createElement(
                      'tr',
                      { className: matrixHoverIndex === document.id ? styles.matrixSelected2 : '' },
                      _react2.default.createElement(
                        'td',
                        null,
                        document.globalIndex + 1
                      ),
                      _react2.default.createElement(
                        'td',
                        {
                          className: matrixHoverRelatedIndex === document.id ? styles.matrixSelected : '' },
                        document.label
                      ),
                      matrix.map(function (section2) {
                        return section2.documents.map(function (document2) {
                          return _react2.default.createElement(
                            'td',
                            { onMouseOver: _this3.handleMouseOver.bind(_this3, document.id, document2.id),
                              onClick: _this3.handleMatrixClick.bind(_this3, document.id, document2.id) },
                            requirements && requirements[document.id] && requirements[document.id].indexOf(document2.id) > -1 ? _react2.default.createElement(
                              'span',
                              null,
                              'X'
                            ) : _react2.default.createElement(
                              'span',
                              null,
                              '\xA0'
                            )
                          );
                        });
                      })
                    );
                  })
                );
              }) : _react2.default.createElement(
                'p',
                null,
                'Aucune section.'
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: styles.box },
            _react2.default.createElement(
              'h1',
              { className: styles.boxTitle },
              _react2.default.createElement(
                _reactRouter.Link,
                { activeClassName: styles.activeItem, className: styles.documentLink, to: '/schoollevels/' + schoolLevel._id },
                schoolLevel.name
              ),
              '\xA0> ',
              chapter.title
            ),
            _react2.default.createElement('div', { className: styles.boxBar })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              'section',
              { className: styles.box },
              !editing ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'div',
                    { className: styles.propertyName },
                    'Titre'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.propertyValue },
                    chapter.title
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'div',
                    { className: styles.propertyName },
                    'URL'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.propertyValue },
                    chapter.slug
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'div',
                    { className: styles.propertyName },
                    'Publi\xE9'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.propertyValue },
                    chapter.published ? 'Oui' : 'Non'
                  )
                ),
                _react2.default.createElement(
                  'button',
                  { className: styles.button, onClick: this.handleStartEditing },
                  'Modifier'
                ),
                _react2.default.createElement(
                  'button',
                  { className: styles.button, onClick: this.handleOpenMatrixModal },
                  'Voir la matrice'
                )
              ) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  { onClick: this.handleRemoveChapter },
                  'Supprimer le chapitre'
                ),
                _react2.default.createElement(
                  'form',
                  { className: styles.form },
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'label',
                      { className: styles.inputFieldLabel, htmlFor: 'name' },
                      'Titre'
                    ),
                    _react2.default.createElement('input', { className: styles.inputFieldInput, type: 'text',
                      name: 'title',
                      value: title,
                      onChange: this.handleFieldChange.bind(null, 'title') }),
                    _react2.default.createElement(
                      'span',
                      null,
                      fieldErrors.name
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'label',
                      { className: styles.inputFieldLabel, htmlFor: 'name' },
                      'URL'
                    ),
                    _react2.default.createElement('input', { className: styles.inputFieldInput, type: 'text',
                      name: 'slug',
                      value: slug,
                      disabled: 'disabled',
                      onChange: this.handleFieldChange.bind(null, 'slug') }),
                    _react2.default.createElement(
                      'span',
                      null,
                      fieldErrors.slug
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'label',
                      { className: styles.inputFieldLabel, htmlFor: 'name' },
                      'Publi\xE9'
                    ),
                    _react2.default.createElement('input', { type: 'checkbox',
                      name: 'published',
                      checked: published,
                      onClick: this.togglePublish })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement('input', { className: styles.documentSaveButton,
                      type: 'cancel',
                      value: 'Annuler',
                      onClick: this.handleStopEditing }),
                    _react2.default.createElement(
                      _reactLadda2.default,
                      { className: styles.button,
                        'data-style': 'slide-down',
                        loading: saving, onClick: this.handleSaveChapter },
                      'Enregistrer'
                    )
                  )
                )
              )
            ),
            !editing ? _react2.default.createElement(
              'section',
              { className: styles.box },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  { className: styles.boxSubtitle },
                  'Sections'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'button',
                    { className: styles.button, onClick: this.handleStartSorting.bind(null, -1) },
                    'Trier les sections'
                  )
                ),
                _react2.default.createElement(
                  'table',
                  { className: styles.listing },
                  _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'th',
                        null,
                        '#'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        '\xA0'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Titre'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Type'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'URL'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Documents'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Publi\xE9'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        '\xA0'
                      )
                    )
                  ),
                  orderedSections.length > 0 ? orderedSections.map(function (section, index) {
                    return _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        { key: index, className: styles.sectionRow },
                        _react2.default.createElement(
                          'td',
                          null,
                          section.rank
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          '\xA0'
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          section.title
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          section.iconClass
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          section.slug
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          section.documents.length
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          section.published ? 'Oui' : 'Non'
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          _react2.default.createElement('i', { className: styles.iconButton + ' fa fa-pencil',
                            'aria-hidden': 'true',
                            onClick: _this3.handleStartEditingSection.bind(null, index) }),
                          section.documents.length === 0 ? _react2.default.createElement('i', { className: styles.iconButton + ' fa fa-trash-o',
                            'aria-hidden': 'true',
                            onClick: _this3.handleStartDeletingSection.bind(null, index) }) : null
                        )
                      ),
                      section.documents.length > 0 ? section.documents.sort(function (first, second) {
                        return first.rank - second.rank;
                      }).map(function (documentReference, documentIndex) {
                        return _react2.default.createElement(
                          'tr',
                          { key: documentIndex },
                          _react2.default.createElement(
                            'td',
                            null,
                            '\xA0'
                          ),
                          _react2.default.createElement(
                            'td',
                            null,
                            documentReference.rank
                          ),
                          _react2.default.createElement(
                            'td',
                            null,
                            documentReference._id.type === 'video' && _react2.default.createElement(
                              'span',
                              null,
                              documentReference._id.title
                            ),
                            documentReference._id.type === 'exercisesSheet' && _react2.default.createElement(
                              _reactRouter.Link,
                              { activeClassName: styles.activeItem, className: styles.documentLink,
                                to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id + '/documents/' + documentReference._id._id },
                              documentReference._id.title
                            ),
                            documentReference._id.type === 'lessonSheet' && _react2.default.createElement(
                              _reactRouter.Link,
                              { activeClassName: styles.activeItem, className: styles.documentLink,
                                to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id + '/lessons/' + documentReference._id._id },
                              documentReference._id.title
                            ),
                            documentReference._id.type === 'mcq' && _react2.default.createElement(
                              _reactRouter.Link,
                              { activeClassName: styles.activeItem, className: styles.documentLink,
                                to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id + '/mcq/' + documentReference._id._id },
                              documentReference._id.title
                            ),
                            documentReference._id.type === 'quiz' && _react2.default.createElement(
                              _reactRouter.Link,
                              { activeClassName: styles.activeItem, className: styles.documentLink,
                                to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id + '/quiz/' + documentReference._id._id },
                              documentReference._id.title,
                              ' ',
                              documentReference._id.isTest && '💯'
                            )
                          ),
                          _react2.default.createElement(
                            'td',
                            null,
                            documentReference._id.type
                          ),
                          _react2.default.createElement(
                            'td',
                            null,
                            documentReference._id.slug
                          ),
                          _react2.default.createElement(
                            'td',
                            null,
                            '\xA0'
                          ),
                          _react2.default.createElement(
                            'td',
                            null,
                            documentReference._id.published ? 'Oui' : 'Non'
                          ),
                          _react2.default.createElement(
                            'td',
                            null,
                            _react2.default.createElement('i', { className: styles.iconButton + ' fa fa-pencil',
                              'aria-hidden': 'true',
                              onClick: _this3.handleStartEditingDocument.bind(null, index, documentIndex) }),
                            _react2.default.createElement('i', { className: styles.iconButton + ' fa fa-copy',
                              'aria-hidden': 'true',
                              onClick: _this3.handleStartCopyDocument.bind(null, index, documentIndex) }),
                            _react2.default.createElement('i', { className: styles.iconButton + ' fa fa-trash-o',
                              'aria-hidden': 'true',
                              onClick: _this3.handleStartDeletingDocument.bind(null, index, documentIndex) })
                          )
                        );
                      }) : _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          null,
                          '\xA0'
                        ),
                        _react2.default.createElement(
                          'td',
                          { colSpan: '7' },
                          'Aucun document dans cette section.'
                        )
                      ),
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          null,
                          '\xA0'
                        ),
                        _react2.default.createElement(
                          'td',
                          { colSpan: '6', className: styles.sectionButtons },
                          _react2.default.createElement(
                            'button',
                            { className: styles.button, onClick: _this3.handleStartAddingDocument.bind(null, index) },
                            'Ajouter un document'
                          ),
                          section.documents.length > 1 ? _react2.default.createElement(
                            'button',
                            { className: styles.button, onClick: _this3.handleStartSorting.bind(null, index) },
                            'Trier les documents'
                          ) : null
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          '\xA0'
                        )
                      )
                    );
                  }) : _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { colSpan: '8' },
                        'Aucune section.'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'button',
                  { className: styles.button, onClick: this.handleStartAddingSection },
                  'Ajouter une section'
                )
              )
            ) : null
          )
        );
      }

      return null;
    }
  }]);
  return Chapter;
}(_react.Component), _class3.propTypes = {
  schoolLevels: _react.PropTypes.array.isRequired,
  chapter: _react.PropTypes.object.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  loading: _react.PropTypes.bool.isRequired,
  saving: _react.PropTypes.bool.isRequired,
  copying: _react.PropTypes.bool.isRequired,
  copyError: _react.PropTypes.object,
  routeParams: _react.PropTypes.object.isRequired
}, _temp3)) || _class2) || _class2);
exports.default = Chapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Chapter/Chapter.js
// module id = 1168
// module chunks = 0